import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    user: null,
    userLocation: null,
  },
  mutations: {
    updateToken: (state, token) => {
      state.token = token;
    },
    updateUser: (state, user) => {
      state.user = user;
    },
    updateUserLocation: (state, location) => {
      state.userLocation = location;
    },
  },
  actions: {
    setToken: (context, token) => {
      context.commit('updateToken', token);
    },
    setUser: (context, user) => {
      context.commit('updateUser', user);
    },
    setUserLocation: (context, location) => {
      context.commit('updateUserLocation', location);
    },
  }
})